// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__ZdDiz","validationTips":"StatementDescriptor_validationTips__2Dwjl"};